export default __webpack_public_path__ + "static/topNavItems-dont-2-light-6cea04b6b95d4f9bfc5b9975b6754c133691e87488c3d70123a7876b0df3827c.png";